module.exports = __webpack_public_path__ + "img/youtube_white_logo.31109fb9.png";